import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";

import { Button, Card, Icon, Label } from "semantic-ui-react";
import { styled, useTheme } from "styled-components";

import util from "utils/utils";

import {
  IdeaMeta as GroupMeta,
  IdeaCoverImage,
  IdeaInfo,
} from "components/lib/Ideas/IdeaView/IdeaViewStyles";
import { ShadowedCard } from "components/lib/UI";

const GroupInfo = styled(IdeaInfo)`
  flex: 1;
  max-height: 40px;
  border-right: none;
  p {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
`;

const CoverImage = styled(IdeaCoverImage)`
  background-color: ${({ theme }) => theme.secondaryColour};
`;

const GroupCardContainer = styled.div`
  display: flex;
  align-self: stretch;
  align-items: center;
  padding: 7.5px;
  border-radius: 5px;
  height: 55px;
  flex: 1;
  h4 {
    margin: 0;
  }
  background-color: #fff;
  max-width: 100%;
  border: 1px solid #e9ebee;
  cursor: pointer;
  &:not(:last-of-type) {
    margin-bottom: 10px;
  }
  &:hover {
    background-color: #eeeff1;
  }
  a,
  p,
  h4 {
    color: #000;
  }
`;

const GroupCard = ({ group }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <ShadowedCard
      onCardClicked={() => {
        navigate(`/groups/${group._id}`);
      }}
    >
      <div
        style={{
          width: "100%",
          height: "100px",
          backgroundImage: `url(${util.groupCoverImage(group)})`,
          backgroundColor: theme.secondaryColour,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center center",
          borderTopLeftRadius: 7,
          borderTopRightRadius: 7,
        }}
      />
      <Card.Content>
        <Card.Header>{group.name}</Card.Header>
        {group.description && <Card.Meta>{group.description} </Card.Meta>}
      </Card.Content>
      <Button
        primary
        style={{ color: "#fff", textTransform: "uppercase", minHeight: 50 }}
      >
        {t("generic.viewType", { entity: "Group" })}
        <Icon name="arrow alternate circle right outline" />
      </Button>
    </ShadowedCard>
  );
};

export const GroupCardListView = ({ group }) => (
  <GroupCardContainer as={Link} to={`/groups/${group._id}`}>
    <CoverImage
      $coverImage={
        group?.coverImage ? util.groupCoverImage(group, "300x300")
        : group?.bannerImage ?
          util.groupBannerImage(group)
        : "https://cdn.simplydo.co.uk/images/groupCoverImage.png"
      }
      $isGroup
    />
    <GroupInfo $isGroup>
      <div>
        <h4>{group.name}</h4>
      </div>
      {group.description ?
        <div>
          <p>{group.description}</p>
        </div>
      : null}
    </GroupInfo>
    <GroupMeta $isGroup>
      {group.isLeader ?
        <Label size="tiny" color="purple">
          <Icon name="rocket" />
          Leader
        </Label>
      : null}
    </GroupMeta>
  </GroupCardContainer>
);

export default GroupCard;
